import { Component, Inject, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import get from 'lodash-es/get';

import { CAMPAIGN_CONSTANTS } from '@finder/shared/constants/app.constants';
import { LazyLoaderService } from '@finder/shared/services/lazy-loader/lazy-loader-service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { urlKebab } from '@finder/shared/utils/url/urlKebab';
import { RemoveFinderClassesProvider, REMOVE_FINDER_CLASSES } from '@finder/shared/utils/dom/removeFinderClasses';
import { FinderThemeService } from '@finder/shared/services/theme-service/finder-theme.service';
import { DYNAMIC_LOADER_CONSTANTS } from '@finder/features/dynamic-loader/dynamic-loader.constants';
import { DOCUMENT } from '@angular/common';
import { CampaignComponent } from '../campaign/campaign.component';
import { DetailComponent } from '../detail/detail.component';

@Component({
    selector: 'app-dynamic-loader',
    template: '',
    styleUrls: ['./dynamic-loader.component.scss'],
    standalone: true,
})
export class DynamicLoaderComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private viewContainerRef: ViewContainerRef,
        private lazyLoad: LazyLoaderService,
        private renderer: Renderer2,
        private winRef: WindowRef,
        private finderThemeService: FinderThemeService,
        @Inject(DOCUMENT) private document: Document,
        @Inject(REMOVE_FINDER_CLASSES) private removeFinderClasses: RemoveFinderClassesProvider,
    ) {}

    ngOnInit() {
        const data = get(this.route.snapshot.data, DYNAMIC_LOADER_CONSTANTS.routeData);
        this.processData(data);
    }

    processData(data) {
        const isCampaign = get(data, CAMPAIGN_CONSTANTS.isCampaign, false);
        this.viewContainerRef.clear();
        let componentToLoad = DYNAMIC_LOADER_CONSTANTS.finderDetail;
        if (isCampaign) {
            // Lazy Load campaign component
            componentToLoad = DYNAMIC_LOADER_CONSTANTS.finderCamapign;
        }

        // Lazy Load details component
        /**
         * Create a new lazyLoadComponent method
         * https://v18.angular.dev/guide/components/programmatic-rendering#using-viewcontainerref
         */
        if (isCampaign) {
            this.viewContainerRef.createComponent(CampaignComponent);
        } else {
            this.viewContainerRef.createComponent(DetailComponent);
        }

        // Remove existing finder classes
        const body = this.document.body;
        this.removeFinderClasses(body, this.renderer);

        // Create class name for path
        // Be sure to remove the locale - this bites us when targeting pages
        const urlClass = urlKebab(this.winRef.nativeWindow);

        // Add classes
        this.finderThemeService.addClassToBody(componentToLoad);
        this.finderThemeService.addClassToBody(urlClass);
    }
}
